module.exports = __webpack_public_path__ + "img/20220218_101849.5a8423db.jpg";